// // ========== IMPORTS ==========
// import React, { useState } from 'react'
// import ContentsBorderImage from '../../assets/images/ARISE WEBSITE_microsite-08.png';
// import WhoShouldEnrollImage from '../../assets/images/ARISE WEBSITE_microsite-09.webp';
// import FlagInactive from '../../assets/images/svg/Flag - Inactive.svg';
// import FlagActive from '../../assets/images/svg/Flag - Active.svg';
// import RocketInactive from '../../assets/images/svg/Rocket - Inactive.svg';
// import RocketActive from '../../assets/images/svg/Rocket - Active.svg';
// import StudentInactive from '../../assets/images/svg/Student - Inactive.svg';
// import StudentActive from '../../assets/images/svg/Student - Active.svg';
// import HouseInactive from '../../assets/images/svg/House - Inactive.svg';
// import HouseActive from '../../assets/images/svg/House - Active.svg';
// import BulbInactive from '../../assets/images/svg/Bulb - Inactive.svg';
// import BulbActive from '../../assets/images/svg/Bulb - Active.svg';
// import WhoShouldEnrollCardImageTwo from '../../assets/images/ARISE WEBSITE_microsite-17.png';
// import WhoShouldEnrollCardImageThree from '../../assets/images/ARISE WEBSITE_microsite-14.png';
// import WhoShouldEnrollCardImageFour from '../../assets/images/ARISE WEBSITE_microsite-16.png';
// import WhoShouldEnrollCardImageFive from '../../assets/images/ARISE WEBSITE_microsite-15.png';

// import '../../assets/styles/WhoShouldEnroll.css'

// // ========== COMPONENT ==========
// const WhoShouldEnroll = () => {

//   // ========== HOOKS ==========
//   const [isHoveredFlag, setIsHoveredFlag] = useState(false);
//   const [isHoveredRocket, setIsHoveredRocket] = useState(false);
//   const [isHoveredStudent, setIsHoveredStudent] = useState(false);
//   const [isHoveredHouse, setIsHoveredHouse] = useState(false);
//   const [isHoveredBulb, setIsHoveredBulb] = useState(false);


//   // ========== RENDER ==========
//   return (
//     <section className='whoshould-enroll my-5'>
//       <div className='custom-padding'>
//         <div className='whoshould-enroll-title-box mt-5 d-flex justify-content-center align-items-center'>
//           <div className='box-design'>
//             <article className='font-bold text-start fs-1 mb-0'>Who Should Enroll?</article>
//             <div className='img-box'>
//               <img
//                 src={ContentsBorderImage}
//                 alt='Contents Border Image'
//               />
//             </div>
//           </div>

//         </div>
//         <div className='whoshould-enroll-content-box mt-3 mb-5'>
//           <div className="row align-items-start">
//             <div className="col-6">
//               <div className='img-box'>
//                 <img src={WhoShouldEnrollImage} alt='Who Should Enroll' />
//               </div>
//             </div>
//             <div className="col-6">
//               <div className="row align-items-start">
//                 <div className="col-6">
//                   <div className='whoshould-card p-3' onMouseEnter={() => setIsHoveredFlag(true)} onMouseLeave={() => setIsHoveredFlag(false)}>
//                     <img src={isHoveredFlag ? FlagActive : FlagInactive} alt='Who Should Enroll' />
//                     <article className='font-medium fs-5'>Future leaders looking for</article>
//                     <article className='font-medium fs-5'>impact and recognition</article>
//                   </div>
//                 </div>
//                 <div className="col-6">
//                   <div className='whoshould-card p-3' onMouseEnter={() => setIsHoveredRocket(true)} onMouseLeave={() => setIsHoveredRocket(false)}>
//                     <img src={isHoveredRocket ? RocketActive : RocketInactive} alt='Who Should Enroll' />
//                     <article className='font-medium fs-5'>Students currently in Undergraduate, Post-graduate,</article>
//                     <article className='font-medium fs-5'> and Diploma Courses</article>
//                   </div>
//                 </div>
//               </div>
//               <div className="row align-items-start mt-3">
//                 <div className="col-6">
//                   <div className='whoshould-card p-3' onMouseEnter={() => setIsHoveredStudent(true)} onMouseLeave={() => setIsHoveredStudent(false)}>
//                     {/* <img src={isHoveredStudent ? StudentActive : StudentInactive} alt='Who Should Enroll' />
//                       <article className='font-medium fs-5'>First-generation</article>
//                       <article className='font-medium fs-5'>innovators</article> */}


//                     <img
//                       src={isHoveredBulb ? BulbActive : BulbInactive}
//                       alt="Who Should Enroll"
//                       className="mb-3"
//                     />
//                     <article className="font-medium fs-5">Youth with startup dreams or</article>
//                     <article className="font-medium fs-5">community-based ideas</article>
//                   </div>
//                 </div>
//                 <div className="col-6">
//                   <div className='whoshould-card p-3' onMouseEnter={() => setIsHoveredHouse(true)} onMouseLeave={() => setIsHoveredHouse(false)}>
//                     <img src={isHoveredHouse ? HouseActive : HouseInactive} alt='Who Should Enroll' />
//                     <article className='font-medium fs-5'>Students from Engineering, Science, Arts and Commerce backgrounds</article>
//                     {/* <article className='font-medium fs-5'>Tier 2 & 3 towns</article> */}
//                   </div>
//                 </div>
//               </div>
//               <div className="row align-items-start mt-3">
//                 <div className="col-6">
//                   <div
//                     className="whoshould-card p-3 d-flex flex-column "
//                     onMouseEnter={() => setIsHoveredBulb(true)}
//                     onMouseLeave={() => setIsHoveredBulb(false)}
//                   >
//                     <img src={isHoveredStudent ? StudentActive : StudentInactive} alt='Who Should Enroll' />
//                     <article className='font-medium fs-5'>First-generation</article>
//                     <article className='font-medium fs-5'>innovators</article>
//                   </div>
//                 </div>


//               </div>
//             </div>



//           </div>

//           <div className='content-box'>

//           </div>

//         </div>
//       </div>
//     </section>
//   )

// }

// export default WhoShouldEnroll






import React, { useState } from "react";
import { motion } from "framer-motion"; // ✅ import Framer Motion
import ContentsBorderImage from "../../assets/images/ARISE WEBSITE_microsite-08.png";
import WhoShouldEnrollImage from "../../assets/images/ARISE WEBSITE_microsite-09.webp";
import FlagInactive from "../../assets/images/svg/Flag - Inactive.svg";
import FlagActive from "../../assets/images/svg/Flag - Active.svg";
import RocketInactive from "../../assets/images/svg/Rocket - Inactive.svg";
import RocketActive from "../../assets/images/svg/Rocket - Active.svg";
import StudentInactive from "../../assets/images/svg/Student - Inactive.svg";
import StudentActive from "../../assets/images/svg/Student - Active.svg";
import HouseInactive from "../../assets/images/svg/House - Inactive.svg";
import HouseActive from "../../assets/images/svg/House - Active.svg";
import BulbInactive from "../../assets/images/svg/Bulb - Inactive.svg";
import BulbActive from "../../assets/images/svg/Bulb - Active.svg";
import "../../assets/styles/WhoShouldEnroll.css";

const cardVariants = {
  hidden: { opacity: 0, y: 50 }, // starts below & invisible
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.3, duration: 0.6, ease: "easeOut" }, // staggered
  }),
};

const WhoShouldEnroll = () => {
  const [isHoveredFlag, setIsHoveredFlag] = useState(false);
  const [isHoveredRocket, setIsHoveredRocket] = useState(false);
  const [isHoveredStudent, setIsHoveredStudent] = useState(false);
  const [isHoveredHouse, setIsHoveredHouse] = useState(false);
  const [isHoveredBulb, setIsHoveredBulb] = useState(false);

  return (
    <section className="whoshould-enroll my-5">
      <div className="custom-padding">
        <div className="whoshould-enroll-title-box mt-5 d-flex justify-content-center align-items-center">
          <div className="box-design">
            <article className="font-bold text-start fs-1 mb-0">
              Who Should Enroll?
            </article>
            <div className="img-box">
              <img src={ContentsBorderImage} alt="Contents Border Image" />
            </div>
          </div>
        </div>

        <div className="whoshould-enroll-content-box mt-3 mb-5">
          <div className="row align-items-start">
            <div className="col-6">
              <div className="img-box">
                <img src={WhoShouldEnrollImage} alt="Who Should Enroll" />
              </div>
            </div>

            <div className="col-6">
              <div className="row align-items-start">
                {[ // ✅ all cards in array for cleaner stagger
                  {
                    img: isHoveredFlag ? FlagActive : FlagInactive,
                    setHover: setIsHoveredFlag,
                    text: ["Future leaders looking for", "impact and recognition"],
                  },
                  {
                    img: isHoveredRocket ? RocketActive : RocketInactive,
                    setHover: setIsHoveredRocket,
                    text: [
                      "Students currently in UG, PG,",
                      "and Diploma Courses",
                    ],
                  },
                  {
                    img: isHoveredBulb ? BulbActive : BulbInactive,
                    setHover: setIsHoveredBulb,
                    text: ["Students with startup dreams or community based ideas"],
                  },
                  {
                    img: isHoveredHouse ? HouseActive : HouseInactive,
                    setHover: setIsHoveredHouse,
                    text: [
                      "Students from Engineering, Science & Arts backgrounds",
                    ],
                  },
                  {
                    img: isHoveredStudent ? StudentActive : StudentInactive,
                    setHover: setIsHoveredStudent,
                    text: ["First-generation innovators eager to build business"], //First-generation innovators eager to build their first venture or project.
 
                  },
                ].map((card, i) => (
                  <motion.div
                    key={i}
                    className="col-6 mb-3"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: false, amount: 0.2 }}
                    variants={cardVariants}
                    custom={i} //  pass index for stagger delay
                  >
                    <div
                      className="whoshould-card p-3"
                      onMouseEnter={() => card.setHover(true)}
                      onMouseLeave={() => card.setHover(false)}
                    >
                      <img src={card.img} alt="Who Should Enroll" />
                      {card.text.map((line, j) => (
                        <article key={j} className="font-medium fs-5">
                          {line}
                        </article>
                      ))}
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoShouldEnroll;
